export { default as translations } from './translations.json';

/**
 * Get floor plan from listing.
 * @param {Object|null} listing
 * @returns {Object|null}
 */
export const getFloorPlan = (listing) =>
  listing?.attributes?.publicData?.floorPlan || null;

export const hasFloorPlan = (listing) => !!getFloorPlan(listing);
